import {PdCollectionModeEnum} from '../model/dto/enum/pd-collection-mode.enum';
import {PdContractEventObsoleteReasonEnum} from '../model/dto/enum/pd-contract-event-obsolete-reason.enum';
import {PdContractEventStatusEnum} from '../model/dto/enum/pd-contract-event-status.enum';
import {PdEventTypeEnum} from '../model/dto/enum/pd-event-type.enum';
import {PdExportChannelEnum} from '../model/dto/enum/pd-export-channel.enum';
import {PdProcessingKindEnum} from '../model/dto/enum/pd-processing-kind.enum';
import {PdRunStatusEnum} from '../model/dto/enum/pd-run-status.enum';
import {ProcessingStatusEnum} from '../model/dto/enum/processing-status.enum';

// German labels of the pd enums (identical to the backend uiLabel). Enum files carry the enum only.

/** German labels of {@link PdCollectionModeEnum}. */
export const PD_COLLECTION_MODE_LABELS: Record<PdCollectionModeEnum, string> = {
    [PdCollectionModeEnum.DELTA]: 'Delta',
    [PdCollectionModeEnum.FULL]: 'Vollabgleich',
};

/** German labels of {@link PdContractEventObsoleteReasonEnum}. */
export const PD_CONTRACT_EVENT_OBSOLETE_REASON_LABELS: Record<PdContractEventObsoleteReasonEnum, string> = {
    [PdContractEventObsoleteReasonEnum.SUPERSEDED]: 'Durch neueres Ereignis ersetzt',
    [PdContractEventObsoleteReasonEnum.REVERTED]: 'Änderung zurückgenommen',
    [PdContractEventObsoleteReasonEnum.CONTRACT_LEFT_PARTNER]: 'Vertrag nicht mehr beim Partner',
    [PdContractEventObsoleteReasonEnum.NOT_RELEVANT]: 'Für den Partner nicht relevant',
};

/** German labels of {@link PdContractEventStatusEnum}. */
export const PD_CONTRACT_EVENT_STATUS_LABELS: Record<PdContractEventStatusEnum, string> = {
    [PdContractEventStatusEnum.PENDING]: 'Offen',
    [PdContractEventStatusEnum.OBSOLETE]: 'Überholt',
    [PdContractEventStatusEnum.SENT]: 'Versendet',
};

/** German labels of {@link PdEventTypeEnum} (identical to the backend {@code uiLabel}). */
export const PD_EVENT_TYPE_LABELS: Record<PdEventTypeEnum, string> = {
    [PdEventTypeEnum.STORNO]: 'Storno',
    [PdEventTypeEnum.STORNO_DATE_CHANGE]: 'Änderung Stornodatum',
    [PdEventTypeEnum.REINSTATEMENT]: 'Wiederinkraftsetzung',
    [PdEventTypeEnum.PAYMENT_SUSPENSION]: 'Beitragsaussetzung',
    [PdEventTypeEnum.PAYMENT_SUSPENSION_CHANGE]: 'Änderung Beitragsaussetzung',
    [PdEventTypeEnum.PAYMENT_SUSPENSION_CANCELLATION]: 'Aufhebung Beitragsaussetzung',
};

/** German labels of {@link PdExportChannelEnum}. */
export const PD_EXPORT_CHANNEL_LABELS: Record<PdExportChannelEnum, string> = {
    [PdExportChannelEnum.MOCK]: 'Simulation',
    [PdExportChannelEnum.FILE_TRANSFER]: 'Dateiübertragung',
    [PdExportChannelEnum.NOTIFICATION]: 'Benachrichtigung',
};

/** German labels of {@link PdProcessingKindEnum}. */
export const PD_PROCESSING_KIND_LABELS: Record<PdProcessingKindEnum, string> = {
    [PdProcessingKindEnum.COLLECTION]: 'Sammellauf',
    [PdProcessingKindEnum.EXPORT]: 'Export',
};

/** German labels of {@link PdRunStatusEnum}. */
export const PD_RUN_STATUS_LABELS: Record<PdRunStatusEnum, string> = {
    [PdRunStatusEnum.RUNNING]: 'Läuft',
    [PdRunStatusEnum.COMPLETED]: 'Abgeschlossen',
    [PdRunStatusEnum.FAILED]: 'Fehlgeschlagen',
};

/** German labels of {@link ProcessingStatusEnum}. */
export const PROCESSING_STATUS_LABELS: Record<ProcessingStatusEnum, string> = {
    [ProcessingStatusEnum.IDLE]: 'Bereit',
    [ProcessingStatusEnum.QUEUED]: 'Eingeplant',
    [ProcessingStatusEnum.PROCESSING]: 'In Verarbeitung',
    [ProcessingStatusEnum.FAILED]: 'Fehlgeschlagen',
};
